import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import PopTip from '@component/info/poptip';

const BASE_CLASSNAME = 'file-system-entry';

const buildKeyUpHandler = (callback) => (event) => {
  event.preventDefault();

  if ([' ', 'Spacebar'].includes(event.key)) {
    callback();
  }
};

const FileSystemEntry = ({
  title,
  details,
  actions,
  children,
  className,
  onClick,
}) => {
  const classname = classnames(
    BASE_CLASSNAME,
    { [`${BASE_CLASSNAME}--clickable`]: !!onClick },
    className
  );
  const detailsArray = Array.isArray(details) ? details : [details];

  return (
    <div
      className={classname}
      onClick={onClick}
      role="gridcell"
      tabIndex={0}
      onKeyUp={buildKeyUpHandler(onClick)}
    >
      <div className={`${BASE_CLASSNAME}__header`}>
        <PopTip
          trigger="hover"
          content={<span>{title}</span>}
          offset={10}
          className="filelist__poptip"
        >
          <h6 className={`${BASE_CLASSNAME}__title`} title={title}>
            {title}
          </h6>
        </PopTip>
        {detailsArray.length > 0 && (
          <div className={`${BASE_CLASSNAME}__details`}>
            {detailsArray.map((detail, index) => (
              <span key={index} className={`${BASE_CLASSNAME}__detail`}>
                {detail}
              </span>
            ))}
          </div>
        )}
        {actions && (
          <div className={`${BASE_CLASSNAME}__actions`}>{actions}</div>
        )}
      </div>
      {children && (
        <div className={`${BASE_CLASSNAME}__content`}>{children}</div>
      )}
    </div>
  );
};

FileSystemEntry.propTypes = {
  title: PropTypes.string.isRequired,
  details: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

FileSystemEntry.defaultProps = {
  details: [],
};

export default FileSystemEntry;
